var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text } from '@dixa/lib-shared-habla';
import { useContext, useEffect, useMemo, useState } from 'react';
import { TranslateTextDropdownButton } from 'components/translateTextDropdownButton';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { ConversationContext } from '../ConversationProvider';
import styles from '../message/message.module.scss';
import TextMessage from './TextMessage';
import { getAttachments } from './utils/attachment';
export const MessageTwitter = (_a) => {
    var _b, _c;
    var { message, first, conversationAttributes } = _a, otherProps = __rest(_a, ["message", "first", "conversationAttributes"]);
    const { agentCopilot } = useFeatureFlag(['agent-copilot']);
    const [renderedMessage, setRenderedMessage] = useState(message);
    const [isTranslated, setIsTranslated] = useState(false);
    const { translationLanguageCode } = useContext(ConversationContext);
    const [selectedLanguageCode, setSelectedLanguageCode] = useState();
    useEffect(() => {
        setSelectedLanguageCode(translationLanguageCode);
    }, [translationLanguageCode]);
    const gutterButtons = useMemo(() => {
        if (!agentCopilot || !message.text) {
            return undefined;
        }
        return (_jsx(TranslateTextDropdownButton, { message: message.text, selectedLanguageCode: selectedLanguageCode, onTranslateEnd: (event) => {
                setRenderedMessage((message) => (Object.assign(Object.assign({}, message), { text: event.translatedText })));
                setIsTranslated(true);
            }, onTranslateError: () => {
                setIsTranslated(false);
            }, onRevert: () => {
                setRenderedMessage(message);
                setIsTranslated(false);
            } }));
    }, [agentCopilot, message, selectedLanguageCode]);
    const attachments = useMemo(() => getAttachments(message, { scaleImage: true }), [message]);
    const isPublicTweet = conversationAttributes === null || conversationAttributes === void 0 ? void 0 : conversationAttributes.is_public_content;
    const endUserHandle = (_c = (_b = message.from_contact_point) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.screen_name;
    const twitterMessageDescription = useMemo(() => {
        const integrationContactPointHandle = conversationAttributes === null || conversationAttributes === void 0 ? void 0 : conversationAttributes.integration_contact_point_handle;
        const showDetails = integrationContactPointHandle && first;
        if (isPublicTweet === 'true' && endUserHandle) {
            return (_jsx(Box, Object.assign({ margin: "0 0 0 200" }, { children: _jsx(Text.Paragraph, Object.assign({ variant: "4", subdued: true }, { children: showDetails ? (_jsxs(_Fragment, { children: ["@", endUserHandle, ' ', getMentionedOriginalLinkOrPlainText(endUserHandle, message.external_id), ' ', "@", integrationContactPointHandle] })) : (`@${endUserHandle}`) })) })));
        }
    }, [
        conversationAttributes === null || conversationAttributes === void 0 ? void 0 : conversationAttributes.integration_contact_point_handle,
        endUserHandle,
        first,
        isPublicTweet,
        message.external_id,
    ]);
    return (_jsx(TextMessage, Object.assign({}, otherProps, { message: renderedMessage, attachments: attachments, authorDescription: twitterMessageDescription, showMarkupAndContent: true, gutterButtons: gutterButtons, isTranslated: isTranslated })));
};
function getMentionedOriginalLinkOrPlainText(endUserHandle, twitterMessageId) {
    const mentionedText = 'mentioned';
    if (twitterMessageId) {
        return (_jsx("a", Object.assign({ role: "button", className: styles.mentionedLink, onClick: () => {
                window.open(`https://twitter.com/${endUserHandle}/status/${twitterMessageId}`, '_blank');
            } }, { children: mentionedText })));
    }
    return _jsx(_Fragment, { children: mentionedText });
}
